import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { NmcNmbiFeatureState } from '../interfaces/shared.interface';
import { NmcNmbiStatusAPIActions } from '../actions/nmc-nmbi-status.actions';

const initialState: NmcNmbiFeatureState = {
  nmc: null,
  nmbi: null,
  isLoaded: false,
};

const reducer: ActionReducer<NmcNmbiFeatureState> = createReducer(
  initialState,
  on(
    NmcNmbiStatusAPIActions.loadedNMCStatusSuccessfully,
    (state, { nmcStatus }): NmcNmbiFeatureState => ({
      ...state,
      nmc: nmcStatus,
      isLoaded: true,
    }),
  ),
  on(
    NmcNmbiStatusAPIActions.loadedNMBIStatusSuccessfully,
    (state, { nmbiStatus }): NmcNmbiFeatureState => ({
      ...state,
      nmbi: nmbiStatus,
      isLoaded: true,
    }),
  ),
);

export function nmcNmbiStatusReducer(
  state: NmcNmbiFeatureState = initialState,
  action: Action,
): NmcNmbiFeatureState {
  return reducer(state, action);
}
